import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { ConfigService } from '@app/@core/@config/config.service';

@Injectable({
  providedIn: 'root',
})
export class AnonCampaignGuard implements CanActivate {
  constructor(private configService: ConfigService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const networkData = this.configService.getNetworkData();
    if (!networkData || (!this.configService.networkKnownFromDomain() && !route.paramMap.get('network'))) {
      return this.router.createUrlTree(['/sign-in-404']);
    } else if (this.configService.getNetworkData()?.hasAnonymousCampaigns) {
      return true;
    } else {
      return this.router.createUrlTree([this.configService.getUrl('/sign-in')]);
    }
  }
}
